import React from 'react';
interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  subtitle,
  actions
}: PageHeaderProps) {
  return <div className="mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-472" data-mp="1me4by2koxk60">
      <div data-id="element-473" data-mp="1r65prsxibiy5">
        {eyebrow && <div className="mb-2 text-[12px] font-medium uppercase tracking-[0.14em] text-accent-soft" data-id="element-474" data-mp="1r76z9syvjxdr">
            {eyebrow}
          </div>}
        <h1 className="text-[28px] font-semibold leading-none tracking-tight text-white sm:text-[32px]" data-id="element-475" data-mp="213jzzasu7bi0">
          {title}
        </h1>
        {subtitle && <p className="mt-2 max-w-xl text-[14px] leading-relaxed text-zinc-400" data-id="element-476" data-mp="263xxhywtb31s">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2" data-id="element-477" data-mp="2a2f7qrbj4tnf">{actions}</div>}
    </div>;
}